import { RESOURCES } from "../types";

export const initialData = [
    { type: RESOURCES.Companies, current: 0, limit: 0 },
    { type: RESOURCES.Users, current: 0, limit: 0 },
    { type: RESOURCES.ConfigurationFiles, current: 0, limit: 0 }
];
